import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-dlg-view-image',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './dlg-view-image.component.html',
  styleUrl: './dlg-view-image.component.css',
})
export class DlgViewImageComponent {
  readonly dialogRef = inject(MatDialogRef<DlgViewImageComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  imageUrl: string;
  title?: string;

  constructor() {
    this.imageUrl = this.data.imageUrl;
    this.title = this.data.title;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
